"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DIRECT_SELL = exports.DIRECT_BUY = exports.DIRECT = exports.VIP_REQUEST = exports.VIP_ACCEPT = exports.REQUEST = exports.ACCEPT = void 0;
/**
 * Means or Peer Matching (MPMs) represent the ways in which a user
 * can match with peers for completing a transaction.
 */
exports.ACCEPT = 'ACCEPT';
exports.REQUEST = 'REQUEST';
exports.VIP_ACCEPT = 'VIP_ACCEPT';
exports.VIP_REQUEST = 'VIP_REQUEST';
exports.DIRECT = 'DIRECT';
exports.DIRECT_BUY = 'DIRECT_BUY';
exports.DIRECT_SELL = 'DIRECT_SELL';
